import { isDevelopmentEnvironment } from "../../estada-config";

import { enumUiMode, getMaxUiMode, getUiMode, setMaxUiMode } from "../../uiMode";
import axios from "../../utils/axios";

export const setSession = (token: string | null): void => {
  if (token) {
    localStorage.setItem("token", token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common.Authorization;
  }
};

//
// set User & User Right at login
//
export const setUser = (sUser: string | null): void => {
  if (sUser) {
    localStorage.setItem("user", sUser);
    const user = JSON.parse(sUser);

    if (user.rights?.mode) {
      setMaxUiMode(user.rights.mode);
    } else {
      setMaxUiMode(enumUiMode.user);
    }

    if (isDevelopmentEnvironment()) {
      setMaxUiMode(enumUiMode.developer);
    }

    if (getUiMode() > getMaxUiMode()) {
      state.setUiMode(getMaxUiMode());
    }
    // check if user has onboarding_quiz
    if (user.onboarding_quiz?.role && getUiMode() == enumUiMode.user) {
      const role = user.onboarding_quiz.role;
      if (role === "elektriker" || role === "systemintegrator") {
        state.setUiMode(enumUiMode.expert);
      }
    }
  } else {
    localStorage.removeItem("user");
  }
};
